module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="repeated-item">\r\n    <p class="apex-' +
((__t = (cssClass)) == null ? '' : __t) +
'" style="-ms-word-wrap: break-word">\r\n        <text class="w"><span class="apex-ep-participant">\r\n                ' +
((__t = (participantDisplayName)) == null ? '' : __t) +
'\r\n            </span><span class="apex-name-colon">:&nbsp;</span></text><text class="apex-ep-text">\r\n            ' +
((__t = (text)) == null ? '' : __t) +
'\r\n        </text>\r\n    </p>\r\n</div>\r\n<div\r\n    class="livechat_message_wrapper apexchat_message';
 if(userId == -1){ ;
__p += ' apexchat_system apexchat_rd_received_system';
};

 if(userId == 0){ ;
__p += ' apexchat_visitor apexchat_rd_sent ';
};

 if(userId > 0 || participantId === -7){ ;
__p += ' apexchat_agent apexchat_rd_received';
};
__p += '">\r\n    <div>\r\n        <p class="apexchat_rd_msg_text apexchat_rd_animated apexchat_rd_fadeIn';
 if(userId == -1){ ;
__p += 'Left';
};

 if(userId == 0){ ;
__p += 'Right';
};

 if(userId > 0){ ;
__p += 'Left';
};
__p += ' apexchat_rd_delay_s apexchat_text"\r\n            id="apexchat_chatlog_' +
((__t = (id)) == null ? '' : __t) +
'">\r\n            ' +
((__t = (text)) == null ? '' : __t) +
'\r\n        </p>\r\n    </div>\r\n</div>\r\n<!-- <span aria-hidden="true" id="apexchat_rd_agent_msg_time"\r\n    class="apexchat_rd_timer_span apexchat_rd_animated apexchat_rd_fadeInRight apexchat_rd_delay_s ';
 if(userId == -1){ ;
__p += ' apexchat_rd_float_left ';
};

 if(userId == 0){ ;
__p += ' apexchat_element_hide ';
};

 if(userId > 0){ ;
__p += ' apexchat_rd_float_left ';
};
__p += '"> -->\r\n<!--For Agent-->\r\n<!-- ' +
((__t = (ApexChat.getCurrentFormatedDateTime(createdOn, 'hh:mmtt' ) )) == null ? '' : __t) +
'\r\n</span> -->\r\n<span aria-hidden=" true" id="apexchat_rd_visitor_msg_time"\r\n    class="apexchat_rd_timer_span apexchat_rd_animated apexchat_rd_fadeInLeft apexchat_rd_delay_s ';
 if(userId == 0){ ;
__p += ' visitor_msg_timer ';
};
__p += '">\r\n    <!-- class="apexchat_rd_timer_span apexchat_rd_animated apexchat_rd_fadeInLeft apexchat_rd_delay_s ';
 if(userId == -1){ ;
__p += ' apexchat_element_hide ';
};

 if(userId == 0){ ;
__p += ' apexchat_rd_float_right ';
};

 if(userId > 0){ ;
__p += ' apexchat_element_hide';
};
__p += '"> -->\r\n    <!--For Visitor-->\r\n    ' +
((__t = (ApexChat.getCurrentFormatedDateTime(createdOn, 'hh:mmtt' ) )) == null ? '' : __t) +
'\r\n</span>\r\n<!-- <div class="timestamp_tooltip_agent apexchat_tooltip_container">\r\n    ' +
((__t = (ApexChat.getCurrentFormatedDateTime(createdOn, 'hh:mmtt' ) )) == null ? '' : __t) +
'\r\n</div>\r\n<div class="timestamp_tooltip_visitor apexchat_tooltip_container">\r\n    ' +
((__t = (ApexChat.getCurrentFormatedDateTime(createdOn, 'hh:mmtt' ) )) == null ? '' : __t) +
'\r\n</div> -->';

}
return __p
}